export default __webpack_public_path__ + "static/media/lightofmitra.2e697650.png";